export default __webpack_public_path__ + "static/media/bureaucracy and society in Saudi.559c9d73.pdf";